export const questionConstants = {
    LOAD_REQUEST: 'QUESTION_LOAD_REQUEST',
    LOAD_SUCCESS: 'QUESTION_LOAD_SUCCESS',
    LOAD_FAILURE: 'QUESTION_LOAD_FAILURE',

    SEARCH_REQUEST: 'QUESTION_SEARCH_REQUEST',
    SEARCH_SUCCESS: 'QUESTION_SEARCH_SUCCESS',
    SEARCH_FAILURE: 'QUESTION_SEARCH_FAILURE',

    SELECT_REQUEST: 'QUESTION_SELECT_REQUEST',

    REGISTER_REQUEST: 'QUESTION_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'QUESTION_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'QUESTION_REGISTER_FAILURE',
    REGISTER_RESET: 'QUESTION_REGISTER_RESET',

    DELETE_REQUEST: 'QUESTION_DELETE_REQUEST',
    DELETE_SUCCESS: 'QUESTION_DELETE_SUCCESS',
    DELETE_FAILURE: 'QUESTION_DELETE_FAILURE',

    EDIT_REQUEST: 'QUESTION_EDIT_REQUEST',
    EDIT_SUCCESS: 'QUESTION_EDIT_SUCCESS',
    EDIT_FAILURE: 'QUESTION_EDIT_FAILURE',

    DETAILS_REQUEST: 'QUESTION_DETAILS_REQUEST',
    DETAILS_SUCCESS: 'QUESTION_DETAILS_SUCCESS',
    DETAILS_FAILURE: 'QUESTION_DETAILS_FAILURE',

    PWD_REQUEST: 'QUESTION_PWD_REQUEST',
    PWD_SUCCESS: 'QUESTION_PWD_SUCCESS',
    PWD_FAILURE: 'QUESTION_PWD_FAILURE',

    SHOW_TERMS: 'QUESTION_SHOW_TERMS',
    SHOW_PWD_POPUP: 'QUESTION_SHOW_PWD_POPUP',
}
